module.exports = __webpack_public_path__ + "static/media/manOnTable.045b1cef.svg";